import clsx from 'clsx';
import React from 'react';

import { MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';

const getLabels = ({ permanentDelete, subject, bodySubject }) => {
  return permanentDelete
    ? {
        title: `Permanently Delete this ${subject}?`,
        body: `You are about to permanently delete selected ${bodySubject}/s. Do you wish to proceed?`,
      }
    : {
        title: `Delete this ${subject} ?`,
        body: `You are about to delete selected ${bodySubject}/s. Do you wish to proceed?`,
      };
};
const ConfirmArchiveDocumentModal = (props) => {
  const { onClose, onSubmit, subject, bodySubject, permanentDelete = false } = props;
  const { body, title } = getLabels({
    permanentDelete,
    subject,
    bodySubject,
  });

  return (
    <ModalPopup
      id={'confirmArchive-document-modal'}
      className={clsx('modal--deleteFile')}
      modalType={MODAL_TYPE.danger}
      title={title}
      onClose={onClose}
      onConfirm={onSubmit}
      confirmBtn={{ label: 'Delete' }}
      icon={null}
    >
      <p className={clsx('tw-text-cfo-black tw-m-0')}>{body}</p>
    </ModalPopup>
  );
};

export default ConfirmArchiveDocumentModal;
